import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fad } from '@fortawesome/pro-duotone-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'

// Add all icons to the library
library.add(fas, far, fab, fad, fal)

export type IconType = 'fas' | 'far' | 'fab' | 'fal' | 'fad'

interface IconProps {
  iconType: IconType
  iconName: string
  className?: string
}

export function Icon({
  iconType,
  iconName,
  className,
}: IconProps): JSX.Element {
  // Check if iconName is undefined or null
  if (!iconName) {
    // Return a fallback or default icon
    console.warn(`Icon name is missing for icon type: ${iconType}`)
    return <span className={className || 'inline-block'}>📄</span>
  }

  // Clean the icon name by keeping only visible characters and removing zero-width spaces
  const cleanedIconName = iconName
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/[^\S\r\n]/g, '')

  try {
    // Create the icon prop in the format that FontAwesomeIcon expects
    const iconProp = [iconType, cleanedIconName] as IconProp
    return <FontAwesomeIcon icon={iconProp} className={className} />
  } catch (error) {
    console.warn(`Failed to render icon: ${iconType} ${iconName}`, error)
    // Return a fallback icon
    return <FontAwesomeIcon icon={['fas', 'book']} className={className} />
  }
}
